import React, { createContext, useContext, useState, useEffect } from 'react'
import { fetchData, getWebsiteId } from '../../Assets/API/apiservices'
import moment from 'moment'
import { ORGANIZATION_ID, SUB_ORGANIZATION_ID } from '../../Config/Config'

const ActivityContext = createContext()

export const ActivityProvider = ({ children, pageName }) => {
  const [activitiesData, setActivitiesData] = useState([])
  const [yearsData, setYearsData] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        const website_id = getWebsiteId()
        if (!website_id) throw new Error('Website ID not available')

        const pagesRes = await fetchData(
          `websitepages?website_id=${website_id}&organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}&type=list`
        )
        const targetPage = pagesRes.rows?.find((p) =>
          p.name?.toLowerCase().includes(pageName?.toLowerCase())
        )
        console.log('Target Page:', pagesRes, pageName)
        const website_page_id = targetPage.id

        // ✅ Fetch activities for that page
        const activitiesRes = await fetchData(
          `activities?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}&website_page_id=${website_page_id}&website_id=${website_id}`
        )
        console.log('Activities Response:', activitiesRes)
        const activities = activitiesRes.rows || []
        setActivitiesData(activities)

        // ✅ Unique years from activities
        setYearsData([
          ...new Set(activities.map((item) => moment(item.date).year())),
        ])
      } catch (error) {
        console.error('Error fetching activities:', error)
      }
    })()
  }, [pageName])

  return (
    <ActivityContext.Provider
      value={{ activitiesData, yearsData, setActivitiesData }}
    >
      {children}
    </ActivityContext.Provider>
  )
}

export const useActivity = () => useContext(ActivityContext)
